// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s sk\u00fasenos\u0165", "%(count)s sk\u00fasenosti", "%(count)s sk\u00fasenost\u00ed"];
export const RELATED_REVIEW_ARTICLES = "Recenzie s\u00favisiacich produktov";
export const TO_REVIEW_CENTRE = "do Centra recenzi\u00ed";
export const WIKI_WRITE_YOUR_EXPERIENCE = "Nap\u00ed\u0161 svoju sk\u00fasenos\u0165";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prv\u00e1 a nap\u00ed\u0161 sk\u00fasenos\u0165";
